export function WhatsAppPage() {
  return (
    <div className="page">
      <div className="page-header">
        <h1>WhatsApp</h1>
        <p className="sub">Manage your WhatsApp communications</p>
      </div>
      
      <div className="card">
        <div className="card-body">
          <div style={{ textAlign: 'center', padding: '40px 20px', color: 'var(--muted)' }}>
            <p>WhatsApp integration coming soon!</p>
          </div>
        </div>
      </div>
    </div>
  );
}
